import { render, staticRenderFns } from "./SelectAddressBook.vue?vue&type=template&id=34dd73f8&scoped=true"
import script from "./SelectAddressBook.vue?vue&type=script&lang=js"
export * from "./SelectAddressBook.vue?vue&type=script&lang=js"
import style0 from "./SelectAddressBook.vue?vue&type=style&index=0&id=34dd73f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd73f8",
  null
  
)

export default component.exports